import { BusinessReportOutcomePermission } from "@/modules/snapshots/businessReports.types";
import * as React from "react";
import { BusinessReportOutcomeShareModalUsersRow } from "./usersRow";

interface Props {
  permissions: BusinessReportOutcomePermission[];
  isReadOnly: boolean;
}

export const BusinessReportOutcomeShareModalUsers: React.FC<Props> = ({ permissions, isReadOnly }) => (
  <div className="mt-3">
    <h4 className="mb-2 text-sm font-semibold">People with access</h4>

    {permissions.map(permission => (
      <BusinessReportOutcomeShareModalUsersRow key={permission.id} permission={permission} isReadOnly={isReadOnly} />
    ))}
  </div>
);
